var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div bb-membership-levels>\n<div>\n<h2 class=\"booking-form-header\" translate=\"PUBLIC_BOOKING.MEMBERSHIP_LEVELS.STEP_HEADING\">\n</h2>\n</div>\n<div>\n<div class=\"form-group\" ng-repeat=\"level in membership_level\">\n<span ng-show=\"level.name\">{{level.name}}</span>\n<button type=\"button\" class=\"btn btn-primary btn-block\" ng-click=\"selectLevel(level)\" translate=\"PUBLIC_BOOKING.MEMBERSHIP_LEVELS.SELECT_BTN\">\n</button>\n</div>\n</div>\n</div>\n";
var id1="public-booking/_templates/steps/membership_levels.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/_templates/steps/membership_levels.html
// module id = 1204
// module chunks = 0